export const ExportButtonMessages = {
	MSG_EXPORT_SUCCESS: 'Exportação do arquivo realizada com sucesso!',
	MSG_TITLE_AG_GRID_START_EXPORT:
		'Exportação em andamento! Não atualize a página.',
	MSG_TEXT_AG_GRID_START_EXPORT:
		'A exportação foi iniciada e pode levar alguns minutos. Você será avisado assim que o processo for concluído.',
} as const;

export type ConsensusMessageType =
	(typeof ExportButtonMessages)[keyof typeof ExportButtonMessages];
